export default [

     {
          path: '/rule',
          name: 'Rule',
          component: () => import("@/views/Page/Rule/Rule.vue"),
           meta: {
               title: '#Default# | Rule',
          },
     }
];